import { fetchRequestWithTypes } from './index.js';

export const POST_USER_REQUEST = 'POST_USER_REQUEST';
export const POST_USER_SUCCESS = 'POST_USER_SUCCESS';
export const POST_USER_ERRORED = 'POST_USER_ERRORED';

export const postUser = (body) =>
	fetchRequestWithTypes({
		types: [POST_USER_REQUEST, POST_USER_SUCCESS, POST_USER_ERRORED],
		request: {
			method: 'POST',
			path: '/api/v1/users',
			body: {
				...body,
				no_account: true,
			},
		},
	});

export const PATCH_USER_REQUEST = 'PATCH_USER_REQUEST';
export const PATCH_USER_SUCCESS = 'PATCH_USER_SUCCESS';
export const PATCH_USER_ERRORED = 'PATCH_USER_ERRORED';

export const patchUser = (body) =>
	fetchRequestWithTypes({
		types: [PATCH_USER_REQUEST, PATCH_USER_SUCCESS, PATCH_USER_ERRORED],
		request: {
			method: 'PATCH',
			path: '/api/v1/users/:uuid',
			body,
		},
	});
